export default {"href":"/corgi/pageapps/purchase/_next/public/sprite-3.46.0-a74e71f86.svg#wishlist-v2-filled-large","viewBox":"0 -0.6 26.5 26"}